module.exports = __webpack_public_path__ + "static/img/bg5.47c90d55.png";